module.exports = {"231223001":"北城街道","231223002":"西城街道","231223003":"靖城街道","231223004":"东城街道","231223100":"青冈镇","231223101":"中和镇","231223102":"祯祥镇","231223103":"兴华镇","231223104":"永丰镇","231223105":"芦河镇","231223106":"民政镇","231223107":"柞岗镇","231223108":"劳动镇","231223109":"迎春镇","231223202":"建设乡","231223203":"新村乡","231223206":"昌盛乡","231223209":"德胜乡","231223212":"连丰乡","231223400":"青冈县林场","231223401":"青冈县互利营林站","231223402":"青冈县果树场","231223580":"青冈县种马场","231223581":"青冈县种羊场","231223582":"青冈县原种场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/231223.json
// module id = 735
// module chunks = 0